import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { habitService } from '../../../services/habit.service';
import './ShareHabitModal.css';

const ShareHabitModal = ({ isOpen, onClose, onShare, userId }) => {
  const [habits, setHabits] = useState([]);
  const [selectedHabit, setSelectedHabit] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen && userId) {
      loadHabits();
    }
  }, [isOpen, userId]);

  const loadHabits = async () => {
    try {
      setIsLoading(true);
      const userHabits = await habitService.getHabits(userId);
      setHabits(userHabits);
    } catch (error) {
      console.error('Error loading habits:', error);
      setError('Failed to load habits. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleShare = () => {
    if (!selectedHabit) return;
    onShare(selectedHabit);
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="modal-content"
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.95, opacity: 0 }}
          onClick={e => e.stopPropagation()}
        >
          <div className="modal-header">
            <h2>Share Habit</h2>
            <button className="close-button" onClick={onClose}>×</button>
          </div>
          
          <div className="modal-body">
            {isLoading ? (
              <div className="loading-state">Loading habits...</div>
            ) : error ? (
              <div className="error-state">{error}</div>
            ) : habits.length === 0 ? (
              <div className="empty-state">
                <p>You haven't created any habits yet.</p>
                <p>Create some habits to share them with friends!</p>
              </div>
            ) : (
              <div className="habits-list">
                {habits.map(habit => (
                  <motion.div
                    key={habit.id}
                    className={`habit-item ${selectedHabit?.id === habit.id ? 'selected' : ''}`}
                    onClick={() => setSelectedHabit(habit)}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <div className="habit-info">
                      <h3>{habit.name}</h3>
                      {habit.streak > 0 && (
                        <div className="streak-badge">
                          🔥 {habit.streak} day streak
                        </div>
                      )}
                    </div>
                  </motion.div>
                ))}
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button 
              className="cancel-button" 
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="share-button"
              onClick={handleShare}
              disabled={!selectedHabit || isLoading}
            >
              Share Habit
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ShareHabitModal; 